package com.kinoshazam.screens.rootFlow

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldLarge
import com.kinoshazam.uiKit.theme.Large
import com.kinoshazam.uiKit.theme.UiKitTheme

/**
 * Non-Android platforms: in-app APK update is not available.
 * Show a dismissible notice so the update dialog is never blank.
 */
@Composable
fun StoreUpdateNotice(
    cancel: () -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(16.dp))
            .background(UiKitTheme.colors.color_4)
            .padding(24.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp),
    ) {
        TextLabel(
            state = TextLabelState(
                text = "Update available",
                color = UiKitTheme.colors.color_2,
                textStyle = BoldLarge,
            )
        )
        TextLabel(
            state = TextLabelState(
                text = "Please update Kinoshka from your store or download page.",
                color = UiKitTheme.colors.color_6,
                textStyle = Large,
            )
        )
        Spacer(modifier = Modifier.height(8.dp))
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.End,
        ) {
            TextLabel(
                state = TextLabelState(
                    text = "OK",
                    color = UiKitTheme.colors.color_1,
                    textStyle = BoldLarge,
                ),
                modifier = Modifier
                    .clickable(onClick = cancel)
                    .padding(8.dp),
            )
            Spacer(modifier = Modifier.width(8.dp))
        }
    }
}
